import { render } from "./AntiTrafficking.vue?vue&type=template&id=345efcf0&scoped=true"
import script from "./AntiTrafficking.vue?vue&type=script&lang=js"
export * from "./AntiTrafficking.vue?vue&type=script&lang=js"

import "./AntiTrafficking.vue?vue&type=style&index=0&id=345efcf0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345efcf0"]])

export default __exports__